/* SERAVIÉ – Announcement-Rotation, Sticky-ATC, Free-Shipping-Balken, PDP-Add-ons */
(function () {
  'use strict';

  function rotateAnnounce() {
    var items = document.querySelectorAll('.srv-announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4000);
  }

  function stickyAtc() {
    var bar = document.querySelector('.srv-sticky');
    if (!bar) return;
    var anchor =
      document.querySelector('.srv-sticky-anchor') ||
      document.querySelector('[id^="ProductSubmitButton"]') ||
      document.querySelector('product-form button[type="submit"]');
    if (!anchor) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    io.observe(anchor);
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-srv-sticky-add]');
      if (!btn) return;
      e.preventDefault();
      var form = document.querySelector('product-form form, form[action*="/cart/add"]');
      if (!form) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  }

  function freeShipBar() {
    var nodes = document.querySelectorAll('[data-srv-ship-bar]');
    if (!nodes.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        nodes.forEach(function (node) {
          var threshold = parseInt(node.dataset.srvThreshold || '10000', 10);
          var total = cart.total_price || 0;
          var pct = Math.min(100, Math.round((total / threshold) * 100));
          var fill = node.querySelector('.srv-bar__fill');
          var text = node.querySelector('.srv-bar__text');
          if (fill) fill.style.width = pct + '%';
          if (text) {
            var left = threshold - total;
            text.textContent =
              left > 0
                ? 'Noch ' + (left / 100).toFixed(2).replace('.', ',') + ' € bis zum kostenlosen Versand'
                : 'Kostenloser Versand erreicht';
          }
        });
      })
      .catch(function () {});
  }

  function addons() {
    var box = document.querySelector('[data-srv-addons]');
    if (!box) return;
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form) return;
    form.addEventListener('submit', function () {
      var picked = box.querySelectorAll('input[type="checkbox"]:checked');
      if (!picked.length) return;
      var items = [];
      picked.forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      }).catch(function () {});
    });
  }

  function init() {
    rotateAnnounce();
    stickyAtc();
    freeShipBar();
    addons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:updated', freeShipBar);
  document.addEventListener('shopify:section:load', init);
})();
